import userReducer, { UserState } from 'core/redux/reducers/userSlice'
import filtersReducer, { IFilters } from 'core/redux/reducers/filtersSlice'
import teamAndSportByStoreReducer from 'core/redux/reducers/teamAndSportByStoreSlice'
import { configureStore, Store, Action, combineReducers } from '@reduxjs/toolkit'

export interface AppStore {
  user: UserState
  filters: IFilters
  teamSportByStore: any
}

let store = null

export const createAppStore = (initialState?: AppStore): Store<AppStore, Action<any>> => {
  const rootReducer = combineReducers({
    user: userReducer,
    filters: filtersReducer,
    teamSportByStore: teamAndSportByStoreReducer
  })

  store = configureStore({
    reducer: rootReducer,
    preloadedState: initialState
  })

  return store
}

export default () => {
  if (!store) {
    store = createAppStore()
  }

  return store
}
